<div class="success-container">
  <div class="success-message">
    <div class="icon">
      <i class="fa-regular fa-check"></i>
    </div>
    <span class="font-medium-headline-medium font-color-green-10">
      {{
        boughtCouponAmount === 1
          ? 'Du hast deinen Gutschein erfolgreich gekauft'
          : 'Du hast deine Gutscheine erfolgreich gekauft'
      }}
    </span>
    <div class="flex-c align-start">
      <span class="font-regular-body-large">
        {{
          boughtCouponAmount === 1
            ? 'Herzlichen Glückwunsch, du hast deinen Gutschein erfolgreich erworben:'
            : 'Herzlichen Glückwunsch, du hast deine Gutscheine erfolgreich erworben:'
        }}
      </span>
      <ul>
        <li>
          <span class="font-regular-body-large">
            Wir haben dir eine E-Mail mit
            {{
              boughtCouponAmount === 1
                ? 'deinem Nutzungscode'
                : 'deinen Nutzungscodes'
            }}
            an
            <b>{{ userService.currentUser$.value?.email }}</b>
            gesendet, der nur für einen Einkauf gültig ist.
          </span>
        </li>
      </ul>
    </div>
    <div class="flex-r align-self-center padding-16-0">
      <button
        type="button"
        class="inwi-text-button-large-primary"
        (click)="toSeminarOverview()">
        <div class="button-content">
          <div class="button-text">Kurse ansehen</div>
        </div>
      </button>
    </div>
  </div>
</div>
